import type { Layout } from './OvalLayout';

export const mobileLayouts: Layout[] = [
	{
		theme: 'powder-green',
		ovals: [
			{
				width: 0.5,
				height: 0.5,
				in: {
					x: 0.75
				}
			},
			{
				width: 0.5,
				height: 0.5,
				out: {
					x: 0.75
				}
			},
			{
				width: 0.5,
				height: 0.5,
				out: {
					x: -0.75
				}
			},
			{
				width: 0.5,
				height: 0.5,
				in: {
					x: -0.75
				}
			}
		]
	},
	{
		theme: 'sky-blue',
		invert: true,
		ovals: [
			{
				width: 1,
				height: 0.5,
				in: {
					y: 0.5
				},
				out: {
					y: 0.5
				}
			},
			{
				width: 1,
				height: 0.5,
				in: {
					y: -0.5
				},
				out: {
					y: -0.5
				}
			}
		]
	}
];
